import config from "../config";

let loaded = false;

export async function loadStopsFromAPI() {
  if (loaded) return;
  try {
    const response = await fetch(`${config.apiUrl}stops/public`);
    if (!response.ok) return;
    const stops = await response.json();
    if (Array.isArray(stops) && stops.length > 0) {
      const filtered = stops.filter(
        (stop) => stop.id !== "92c2a532-9701-43e0-9f6d-c59b8241a550"
      );
      config.cities = filtered.map((stop) => ({
        code: stop.code || "",
        value: stop.city,
        label: stop.label || stop.city,
        shortLabel: stop.label || stop.city,
        dropoffAddress: stop.drop_off_description || stop.address,
        address: stop.address + (stop.description ? "\n" + stop.description : ""),
        metro: stop.metro || "",
        zip: parseInt(stop.zipCode) || 0,
        state: stop.state || "",
        group: stop.group || "",
      }));
      loaded = true;
    }
  } catch (err) {
    console.error("Error loading stops from API:", err);
  }
}
